(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-stories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('customer-stories')) {
    customElements.define('customer-stories', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.cards = Array.from(this.track.children);
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.current = this.querySelector('[data-current]');
        this.index = 0;
        this.smooth = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => { this.ticking = false; this.update(); });
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.prev && this.prev.addEventListener('click', () => this.go(this.index - 1));
        this.next && this.next.addEventListener('click', () => this.go(this.index + 1));
        this.dots.forEach((d) => d.addEventListener('click', () => this.go(Number(d.dataset.dot))));
        this.update();
      }
      disconnectedCallback() {
        this.track && this.track.removeEventListener('scroll', this.onScroll);
      }
      go(i) {
        const n = Math.max(0, Math.min(this.cards.length - 1, i));
        this.track.scrollTo({ left: this.cards[n].offsetLeft - this.cards[0].offsetLeft, behavior: this.smooth });
      }
      update() {
        const x = this.track.scrollLeft;
        let best = 0, dist = Infinity;
        this.cards.forEach((c, i) => {
          const d = Math.abs((c.offsetLeft - this.cards[0].offsetLeft) - x);
          if (d < dist) { dist = d; best = i; }
        });
        if (this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4) best = this.cards.length - 1;
        this.index = best;
        this.dots.forEach((d, i) => d.setAttribute('aria-current', i === best ? 'true' : 'false'));
        if (this.current) this.current.textContent = best + 1;
        if (this.prev) this.prev.disabled = best === 0;
        if (this.next) this.next.disabled = best === this.cards.length - 1;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};
    this.setHeaderHeight();
    window.matchMedia('(max-width: 992px)').addEventListener('change', this.setHeaderHeight.bind(this));
    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.createObserver();
  }
  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }
  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }
  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }
  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }
  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }
  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }
  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }
  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    // this.searchModal.close(false);
  }
}
customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
